import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useDeleteAnchorStrategyMutation } from '@/entities/anchor'

import { confirm } from '@/shared/components/ui/confirmer'
import { queryClient } from '@/shared/lib/query-client'

export function useDeleteAnchorStrategy(onSuccess?: () => void) {
	const { t } = useTranslation()

	const deleteAnchorStrategyMutation = useDeleteAnchorStrategyMutation({
		onSuccess: () => {
			onSuccess?.()
			queryClient.invalidateQueries({
				queryKey: ['anchors-strategies'],
			})
			queryClient.invalidateQueries({
				queryKey: ['generated-anchor-families'],
			})
		},
	})
	const handleDeleteStrategy = async (id: string) => {
		confirm({
			title: t('general_detete_confirm_title'),
			description: t('general_detete_confirm_subtitle'),
			actionText: t('general_delete'),
			cancelText: t('general_cancel'),
			ActionProps: {
				variant: 'destructive',
			},
		}).then((answer: boolean) => {
			if (answer) {
				toast.promise(deleteAnchorStrategyMutation.mutateAsync(id), {
					loading: t('toast.entity.deleting', {
						entity: t('entity.anchor_strategy'),
					}),
					success: t('toast.entity.deleted', {
						entity: t('entity.anchor_strategy'),
					}),
					error: t('fatal_error_title'),
				})
			}
		})
	}

	return { handleDeleteStrategy }
}
